// Files the API returns (CSV exports, invoice PDFs) are fetched with the
// signed-in person's bearer token, so a plain link would not work: the bytes
// are saved through a temporary object URL instead.

/** saveBlob offers blob to the person as a file called name. */
export function saveBlob(name: string, blob: Blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
